import Divisions from './divisions'

export default Divisions
